var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title underline mb-5"},[_c('mdb-icon',{attrs:{"icon":"highlighter"}}),_vm._v(" 성취도 평가")],1),_c('stduent-summary')],1)}
var staticRenderFns = []

export { render, staticRenderFns }